"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Eases = require("eases");
;
var Easing;
(function (Easing) {
    Easing[Easing["BackInOut"] = 0] = "BackInOut";
    Easing[Easing["BackIn"] = 1] = "BackIn";
    Easing[Easing["BackOut"] = 2] = "BackOut";
    Easing[Easing["BounceInOut"] = 3] = "BounceInOut";
    Easing[Easing["BounceIn"] = 4] = "BounceIn";
    Easing[Easing["BounceOut"] = 5] = "BounceOut";
    Easing[Easing["CircInOut"] = 6] = "CircInOut";
    Easing[Easing["CircIn"] = 7] = "CircIn";
    Easing[Easing["CircOut"] = 8] = "CircOut";
    Easing[Easing["CubicInOut"] = 9] = "CubicInOut";
    Easing[Easing["CubicIn"] = 10] = "CubicIn";
    Easing[Easing["CubicOut"] = 11] = "CubicOut";
    Easing[Easing["ElasticInOut"] = 12] = "ElasticInOut";
    Easing[Easing["ElasticIn"] = 13] = "ElasticIn";
    Easing[Easing["ElasticOut"] = 14] = "ElasticOut";
    Easing[Easing["ExpoInOut"] = 15] = "ExpoInOut";
    Easing[Easing["ExpoIn"] = 16] = "ExpoIn";
    Easing[Easing["ExpoOut"] = 17] = "ExpoOut";
    Easing[Easing["Linear"] = 18] = "Linear";
    Easing[Easing["QuadInOut"] = 19] = "QuadInOut";
    Easing[Easing["QuadIn"] = 20] = "QuadIn";
    Easing[Easing["QuadOut"] = 21] = "QuadOut";
    Easing[Easing["QuartInOut"] = 22] = "QuartInOut";
    Easing[Easing["QuartIn"] = 23] = "QuartIn";
    Easing[Easing["QuartOut"] = 24] = "QuartOut";
    Easing[Easing["QuintInOut"] = 25] = "QuintInOut";
    Easing[Easing["QuintIn"] = 26] = "QuintIn";
    Easing[Easing["QuintOut"] = 27] = "QuintOut";
    Easing[Easing["SineInOut"] = 28] = "SineInOut";
    Easing[Easing["SineIn"] = 29] = "SineIn";
    Easing[Easing["SineOut"] = 30] = "SineOut";
})(Easing = exports.Easing || (exports.Easing = {}));
var DurationAnimationDefinition = /** @class */ (function () {
    function DurationAnimationDefinition(startValue, endValue, duration, easing) {
        this.startValue = startValue;
        this.endValue = endValue;
        this.duration = duration;
        this.easing = easing || Easing.Linear;
    }
    DurationAnimationDefinition.prototype.start = function (time) {
        return new DurationAnimation(this, time);
    };
    DurationAnimationDefinition.prototype.getDefaultValue = function () {
        return this.startValue;
    };
    return DurationAnimationDefinition;
}());
exports.DurationAnimationDefinition = DurationAnimationDefinition;
var DurationAnimation = /** @class */ (function () {
    function DurationAnimation(definition, startTime) {
        this.definition = definition;
        this.startTime = startTime;
        var easingFn;
        switch (definition.easing) {
            case Easing.BackInOut:
                easingFn = Eases.backInOut;
                break;
            case Easing.BackIn:
                easingFn = Eases.backIn;
                break;
            case Easing.BackOut:
                easingFn = Eases.backOut;
                break;
            case Easing.BounceInOut:
                easingFn = Eases.bounceInOut;
                break;
            case Easing.BounceIn:
                easingFn = Eases.bounceIn;
                break;
            case Easing.BounceOut:
                easingFn = Eases.bounceOut;
                break;
            case Easing.CircInOut:
                easingFn = Eases.circInOut;
                break;
            case Easing.CircIn:
                easingFn = Eases.circIn;
                break;
            case Easing.CircOut:
                easingFn = Eases.circOut;
                break;
            case Easing.CubicInOut:
                easingFn = Eases.cubicInOut;
                break;
            case Easing.CubicIn:
                easingFn = Eases.cubicIn;
                break;
            case Easing.CubicOut:
                easingFn = Eases.cubicOut;
                break;
            case Easing.ElasticInOut:
                easingFn = Eases.elasticInOut;
                break;
            case Easing.ElasticIn:
                easingFn = Eases.elasticIn;
                break;
            case Easing.ElasticOut:
                easingFn = Eases.elasticOut;
                break;
            case Easing.ExpoInOut:
                easingFn = Eases.expoInOut;
                break;
            case Easing.ExpoIn:
                easingFn = Eases.expoIn;
                break;
            case Easing.ExpoOut:
                easingFn = Eases.expoOut;
                break;
            case Easing.Linear:
                easingFn = Eases.linear;
                break;
            case Easing.QuadInOut:
                easingFn = Eases.quadInOut;
                break;
            case Easing.QuadIn:
                easingFn = Eases.quadIn;
                break;
            case Easing.QuadOut:
                easingFn = Eases.quadOut;
                break;
            case Easing.QuartInOut:
                easingFn = Eases.quartInOut;
                break;
            case Easing.QuartIn:
                easingFn = Eases.quartIn;
                break;
            case Easing.QuartOut:
                easingFn = Eases.quartOut;
                break;
            case Easing.QuintInOut:
                easingFn = Eases.quintInOut;
                break;
            case Easing.QuintIn:
                easingFn = Eases.quintIn;
                break;
            case Easing.QuintOut:
                easingFn = Eases.quintOut;
                break;
            case Easing.SineInOut:
                easingFn = Eases.sineInOut;
                break;
            case Easing.SineIn:
                easingFn = Eases.sineIn;
                break;
            case Easing.SineOut:
                easingFn = Eases.sineOut;
                break;
            default:
                easingFn = Eases.linear;
                break;
        }
        this.easing = easingFn;
    }
    DurationAnimation.prototype.getCurrentValue = function (time) {
        time = time === null ? this.startTime : time;
        var factor = (time - this.startTime) / this.definition.duration;
        factor = this.easing(Math.min(factor, 1));
        return this.definition.startValue + ((this.definition.endValue - this.definition.startValue) * factor);
    };
    DurationAnimation.prototype.isComplete = function (time) {
        return this.startTime !== null
            ? (time - this.startTime) > this.definition.duration
            : false;
    };
    return DurationAnimation;
}());
